import {
    ChevronLeft,
    ChevronRight
} from "lucide-react";

export default function Pagination({

    page = 1,

    totalPages = 1,

    onChange

}){

    if(totalPages <= 1){

        return null;

    }

    function goto(target){

        if(

            target < 1 ||

            target > totalPages ||

            target === page

        ){

            return;

        }

        onChange?.(target);

    }

    function renderPages(){

        const pages = [];

        const start =

            Math.max(

                1,

                page - 2

            );

        const end =

            Math.min(

                totalPages,

                page + 2

            );

        if(start > 1){

            pages.push(1);

            if(start > 2){

                pages.push("...");

            }

        }

        for(

            let i = start;

            i <= end;

            i++

        ){

            pages.push(i);

        }

        if(end < totalPages){

            if(end < totalPages - 1){

                pages.push("...");

            }

            pages.push(totalPages);

        }

        return pages;

    }

    return(

        <div className="crm-pagination">

            <button

                className="crm-page-btn"

                disabled={page===1}

                onClick={()=>goto(page-1)}

            >

                <ChevronLeft size={18}/>

            </button>

            {

                renderPages().map(

                    (item,index)=>

                        item==="..."

                        ?

                        <span

                            key={index}

                            className="crm-page-dots"

                        >

                            ...

                        </span>

                        :

                        <button

                            key={item}

                            className={`
                                crm-page-btn
                                ${
                                    item===page
                                    ?
                                    "active"
                                    :
                                    ""
                                }
                            `}

                            onClick={()=>

                                goto(item)

                            }

                        >

                            {item}

                        </button>

                )

            }

            <button

                className="crm-page-btn"

                disabled={

                    page===totalPages

                }

                onClick={()=>goto(page+1)}

            >

                <ChevronRight size={18}/>

            </button>

<style>{`

.crm-pagination{

    display:flex;

    justify-content:center;

    align-items:center;

    gap:8px;

    margin-top:24px;

    flex-wrap:wrap;

}

.crm-page-btn{

    min-width:40px;

    height:40px;

    padding:0 12px;

    border:1px solid #D7DCE3;

    background:#FFF;

    border-radius:10px;

    display:flex;

    align-items:center;

    justify-content:center;

    cursor:pointer;

    transition:.18s;

    color:#475569;

}

.crm-page-btn:hover:not(:disabled){

    border-color:#2563EB;

    color:#2563EB;

    background:#EFF6FF;

}

.crm-page-btn.active{

    background:#2563EB;

    border-color:#2563EB;

    color:#FFF;

}

.crm-page-btn:disabled{

    opacity:.45;

    cursor:not-allowed;

}

.crm-page-dots{

    padding:0 4px;

    color:#94A3B8;

    font-weight:600;

}

`}</style>

        </div>

    );

}